import React, { createContext, useContext, useEffect, useState } from 'react';
import { CallWindow } from '../types';
import { schedulingApi } from '../services/api';

/**
 * The policy's daily calling windows, fetched once for the session.
 *
 * Due states are rendered on every task screen, and the windows are what makes
 * a call placed at 18:00 not late at 18:01. They are ambient config rather than
 * page data — one fetch, read wherever a due state is drawn.
 *
 * The empty list is the honest default: before the fetch lands, and if it
 * fails, every screen reads due states off `due_at` alone, exactly as it did
 * before windows existed.
 */
const CallWindowsContext = createContext<CallWindow[]>([]);

export const CallWindowsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [windows, setWindows] = useState<CallWindow[]>([]);

  useEffect(() => {
    schedulingApi.windows()
      .then((r) => setWindows(r.windows))
      .catch(() => { /* clock-time due states — see above */ });
  }, []);

  return <CallWindowsContext.Provider value={windows}>{children}</CallWindowsContext.Provider>;
};

export const useCallWindows = () => useContext(CallWindowsContext);
